import { gql } from 'graphql-request';
import { PayrollOptOutEmployeeVpfGraphQLRequest, PayrollOptOutEmployeeVpfResponse } from '../types';
import { graphQLApi } from 'utils/Api';

const optOutEmployeeVpfMutation = gql`
  mutation PayrollOptOutEmployeeVpf($input: PayrollOptOutEmployeeVpfInput!) {
    payrollOptOutEmployeeVpf(input: $input) {
      code
      success
      message
      data {
        status
      }
    }
  }
`;

const optOutEmployeeVpf = (queryVariables: PayrollOptOutEmployeeVpfGraphQLRequest) => {
  return graphQLApi<PayrollOptOutEmployeeVpfResponse, PayrollOptOutEmployeeVpfGraphQLRequest>({
    query: optOutEmployeeVpfMutation,
    queryVariables,
  });
};

export default optOutEmployeeVpf;
